export default __webpack_public_path__ + "static/sp-kv-0-95f6be386d0db12b1bf8dbd50c73b3fb.png";